<template>
    <gallery-default v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import GalleryDefault from './GalleryDefault.vue';

export default {
    name: 'GalleryType1',
    inheritAttrs: false,
    components: { GalleryDefault },
};
</script>
